import React, { useEffect, useState } from "react";
import { Table, Image, Modal, Select } from "antd";
// import { useCustomerList } from '../../../api/customer';
import { useAddVCEOrder, useGetVCEByOrderId } from "../../../api/order";
import TableAction from "../../TableAction";
import { useGetUsersListByRole } from "../../../api/profile";
import { useContractByOrderIdList } from "../../../api/contract";
// import { useGetUsersListByRole } from '../../../api/profile';

type ContractTableProps = {
  orderId?: string;
};

const vceColumn = [
  {
    key: "no",
    title: "No.",
    width: 60,
    render: (text: string, record: any, index: number) => <b>#{index + 1}</b>,
  },
  {
    key: "contractNumber",
    dataIndex: "contractNumber",
    title: "Contract Number",
  },
  {
    dataIndex: "fullName",
    title: "Full name",
    render: (text: string, record: any) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 400,
            fontSize: 15,
            gap: 12,
          }}
        >
          {record.avatar_url && (
            <Image
              src={record.avatar_url}
              style={{ width: 30, aspectRatio: 1, borderRadius: 50 }}
            />
          )}
          {record.fullName}
        </div>
      );
    },
  },
  {
    key: "phoneNumber",
    title: "Phone Number",
    dataIndex: "phoneNumber",
  },
  {
    key: "harvestDate",
    dataIndex: "startingDate",
    title: "Harvest Date",
    render: (text: string, record: any) => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 400,
            fontSize: 15,
            gap: 12,
          }}
        >
          {record.startingDate} - {record.dueDate}
        </div>
      );
    },
  },
  {
    key: "status",
    title: "Status",
    dataIndex: "status",
  },
];

const ContractTable: React.FC<ContractTableProps> = ({ orderId }) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const {
    data: contracts,
    isLoading,
    refetch,
  } = useContractByOrderIdList(orderId);
  const [profiles, setProfiles] = useState<any>();
  const [userId, setUserId] = useState<number | undefined>();

  const { data: users } = useGetUsersListByRole("ROLE_VALUE_CHAIN_EXECUTOR");
  const { mutate: assignVCE } = useAddVCEOrder();

  const [searchText, setSearchText] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState(false);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (searchText) {
      const _data = contracts?.data?.data.filter(
        (item: any) =>
          item.contractNumber
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.phoneNumber?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.startingDate
            ?.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.dueDate
            ?.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.status?.toLowerCase().includes(searchText.toLowerCase())
      );
      setTableData(_data);
    } else {
      if (contracts && contracts.data && contracts.data.data) {
        setTableData(contracts.data.data);
      }
    }
  }, [contracts, searchText]);

  const onSubmit = () => {
    if (userId && !isNaN(Number(orderId))) {
      assignVCE({ orderId: Number(orderId), userId: userId });
      refetch();
      setOpen(false);
    }
  };

  return (
    <>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 600,
              fontSize: 27.43,
              color: "black",
            }}
          >
            Select value chain executor
          </div>
        }
        open={open}
        centered
        onOk={onSubmit}
        onCancel={hideModal}
        closable
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Select
            value={userId}
            placeholder="Select value chain executor"
            style={{ width: "100%" }}
            onChange={(val: any) => setUserId(val)}
            options={users?.data?.data?.map((user: any) => {
              return { label: user.fullName, value: user.id };
            })}
          />
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} />
      </div>
      <Table
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        dataSource={tableData}
        columns={vceColumn}
        loading={false}
      />
    </>
  );
};

export default ContractTable;
